/** Backend project types — full set stored in MongoDB. */
export const commissionProjectTypes = [
  "CANVAS_ORIGINAL",
  "BRAND_AI_CAMPAIGN",
  "ALBUM_COVER",
  "DIGITAL_ART",
  "NFT_COLLECTION",
  "PRINTS_LICENSING",
  "MURAL_EVENT",
  "OTHER",
] as const;

export type CommissionProjectType = (typeof commissionProjectTypes)[number];

/** Shown in the UI — maps to backend project types. */
export const commissionProjectChoices = [
  { id: "CANVAS_ORIGINAL", backend: "CANVAS_ORIGINAL" as const },
  { id: "BRAND_AI", backend: "BRAND_AI_CAMPAIGN" as const },
  { id: "ALBUM_DIGITAL", backend: "ALBUM_COVER" as const },
  { id: "OFFICE_COLLECTION", backend: "OTHER" as const },
  { id: "OTHER", backend: "OTHER" as const },
] as const;

export type CommissionProjectChoiceId =
  (typeof commissionProjectChoices)[number]["id"];

export function backendProjectType(
  choiceId: CommissionProjectChoiceId | "",
): CommissionProjectType {
  const match = commissionProjectChoices.find((c) => c.id === choiceId);
  return match?.backend ?? "OTHER";
}

export const commissionBudgetRanges = [
  "UNDER_1500",
  "1500_5000",
  "5000_15000",
  "OVER_15000",
  "FLEXIBLE",
] as const;

export type CommissionBudgetRange = (typeof commissionBudgetRanges)[number];

export const commissionTimelines = [
  "ASAP",
  "ONE_TO_TWO_MONTHS",
  "THREE_PLUS_MONTHS",
  "FLEXIBLE",
] as const;

export type CommissionTimeline = (typeof commissionTimelines)[number];
